import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Button, Dialog, DialogActions, DialogTitle, IconButton, Typography } from "@mui/material";
import { Form, Input } from 'antd';
import React, { useState } from 'react';
import { useForm, } from "react-hook-form";
import { useDispatch } from 'react-redux';
import { NavContext } from '../../App';
import Snackbars from "../../GlobalComponents/Alerts/Snackbars";
import GridContainer from "../../GlobalComponents/Grid/GridContainer";
import GridItem from "../../GlobalComponents/Grid/GridItem";
import H4 from "../../GlobalComponents/TypoGraphy/H4";
import { Colors } from "../../GlobalComponents/Utility/Colors";
import { updateTicketState } from "../../ReduxTLK/features/SAV/TicketSlice";

export default function ResolveTicketModal(props) {
  console.log("🚀 ~ ResolveTicketModal ~ props:", props)
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const openTicket = props.openTicket
  const status = 3
  const dispatch = useDispatch()

  // Show the conformity choice only when the ticket has assignment history
  const histoAffectations = props.histoAffectations ?? [];
  const hasAssignations = Array.isArray(histoAffectations) && histoAffectations.length > 0;

  const handleClose = () => {
    props.setOpenModal(false)
    form.resetFields();
    setAssignationConforme(null);
    setErrorConforme(false);
  }
  const [openErrorBox, setOpenErrorBox] = useState(false);
  const [openSuccessBox, setOpenSuccessBox] = useState(false);
  const context = React.useContext(NavContext)
  const [index, setIndex] = useState(context.maxTabIndex)
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [message, setMessage] = useState("")
  const [cause, setCause] = useState();
  const [note, setNote] = useState();
  const [errorCause, setErrorCause] = useState(false)
  const [assignationConforme, setAssignationConforme] = useState(null);
  const [errorConforme, setErrorConforme] = useState(false);
  const connectionId = localStorage.getItem('connectionId')

  const handleExecute = async (values) => {
    // When assignments exist, the conformity choice is required
    if (hasAssignations && assignationConforme === null) {
      setErrorConforme(true);
      return;
    }

    const textContent = `Le ticket ${openTicket} a été résolu. ${values.note ? values.note : ''}`;
    dispatch(updateTicketState({
      Id: openTicket,
      status: status,
      note: values.note,
      connectionId: connectionId,
      ...(hasAssignations ? { assignationConforme } : {}),
    })).then((res) => {
      handleClose();
      if (res?.payload?.status === 200) {
        setSeverity('success');
        setMessage('Le Ticket est résolu ');
        setOpenSuccessBox(true);
        setCause('');
        setNote();
        props.fetchData();
        props.fetchMessages()
      }
      else {
        setSeverity('error');
        setMessage('Un problème est survenu');
        setOpenErrorBox(true);
        setCause('');
        setNote();
      }
    });
    form.resetFields();
  }

  const { register, control, handleSubmit, reset, formState: { errors } } = useForm({})
  const [formData, setFormData] = useState({})
  const handleChange = (event) => {
    const { name, value } = event.target;
    setNote(value);
  };

  const pickConforme = (value) => {
    setAssignationConforme(value);
    setErrorConforme(false);
  };

  return (
    <>
      <Dialog open={props.openModal} fullWidth maxWidth='sm' sx={{
        '& .MuiPaper-root': {
          borderRadius: '12px',
        },
      }}>
        <DialogTitle>
          <GridContainer>
            <GridItem sx={11.5} sm={11.5} md={11.5} xl={11.5} xxl={11.5}>
              <H4 title={"Êtes vous sûre de vouloir resoudre ce ticket ?"}></H4>
            </GridItem>
            <GridItem sx={0.010} sm={0.010} md={0.010} xl={0.010} xxl={0.010}>
              <IconButton sx={{ marginRight: 0, color: `${Colors.primary}` }} onClick={handleClose}>
                <CloseIcon></CloseIcon>
              </IconButton>
            </GridItem>
          </GridContainer>
        </DialogTitle>

        <Form
          form={form}
          name="control-hooks-resolveTicket"
          onFinish={handleExecute}
          ref={props.formRef}
        >

          <GridContainer
            display='flex'
            justifyContent='center'
            alignItems='flex-start'
            direction='row'
            gap='var(--spacing-3xs, 8px)'
            flex='1 0 0'
          >

            <GridItem sx={12} sm={12} md={12} xl={12} xxl={12} padding='32px 32px 44px 32px'>

              {/* ── Conformité de l'affectation (only when assignments exist) ── */}
              {hasAssignations && (
                <Box sx={{ mb: 3 }}>
                  <Typography sx={{
                    color: 'var(--black, #000)',
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: 400,
                    marginBottom: '10px',
                  }}>
                    L'affectation était-elle conforme ? <span style={{ color: '#EF4444' }}>*</span>
                  </Typography>

                  <Box sx={{ display: 'flex', gap: 1.5 }}>
                    {/* Conforme */}
                    <Box
                      onClick={() => pickConforme(true)}
                      sx={{
                        flex: 1, cursor: 'pointer', userSelect: 'none',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                        height: 48, borderRadius: '12px',
                        border: '1.5px solid',
                        borderColor: assignationConforme === true ? '#0E8A6A' : '#E5E7EB',
                        backgroundColor: assignationConforme === true ? 'rgba(14,138,106,0.08)' : '#fff',
                        color: assignationConforme === true ? '#0E8A6A' : '#6B7280',
                        transition: 'all 0.15s ease',
                        '&:hover': { borderColor: '#0E8A6A', backgroundColor: 'rgba(14,138,106,0.04)' }
                      }}
                    >
                      <CheckCircleIcon sx={{ fontSize: 20 }} />
                      <Typography sx={{ fontSize: 14, fontWeight: assignationConforme === true ? 600 : 500 }}>
                        Conforme
                      </Typography>
                    </Box>

                    {/* Non conforme */}
                    <Box
                      onClick={() => pickConforme(false)}
                      sx={{
                        flex: 1, cursor: 'pointer', userSelect: 'none',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                        height: 48, borderRadius: '12px',
                        border: '1.5px solid',
                        borderColor: assignationConforme === false ? '#D92D20' : '#E5E7EB',
                        backgroundColor: assignationConforme === false ? 'rgba(217,45,32,0.07)' : '#fff',
                        color: assignationConforme === false ? '#D92D20' : '#6B7280',
                        transition: 'all 0.15s ease',
                        '&:hover': { borderColor: '#D92D20', backgroundColor: 'rgba(217,45,32,0.04)' }
                      }}
                    >
                      <CancelIcon sx={{ fontSize: 20 }} />
                      <Typography sx={{ fontSize: 14, fontWeight: assignationConforme === false ? 600 : 500 }}>
                        Non conforme
                      </Typography>
                    </Box>
                  </Box>

                  {errorConforme && (
                    <Typography sx={{ color: '#EF4444', fontSize: 12.5, mt: 0.75 }}>
                      Ce champ est obligatoire !
                    </Typography>
                  )}
                </Box>
              )}

              <Typography sx={{
                color: 'var(--black, #000)',
                fontFamily: 'Inter',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: 'normal',
                marginBottom: '10px',
              }}>
                Descriptions
              </Typography>
              <Form.Item
                name="note"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <TextArea
                  rows={9}
                  autoSize={{ minRows: 9, maxRows: 9 }}
                  placeholder="Decrivez..."
                  count={{}} />
              </Form.Item>

            </GridItem>
          </GridContainer>

          <DialogActions>
            <Form.Item
              style={{ marginTop: '-25px' }}
            >

              <Button
                sx={{
                  textTransform: "none",
                  border: '2px solid #2A66C6',
                  color: '#2A66C6',
                  borderColor: '#2A66C6',
                  borderRadius: '18px',
                  width: '93px',
                  height: '40px',
                }}
                onClick={handleClose} variant="outlined" shape="rounded">Annuler</Button>


              <Button type="submit" variant="contained" shape="rounded"
                sx={{
                  textTransform: "none",
                  '&.MuiButtonBase-root': {
                    color: '#FFFFFF',
                    backgroundColor: '#2A66C6',
                    borderRadius: '32px',
                    height: '40px',
                    width: '160px',
                    minWidth: '100px',
                    marginLeft: 2,
                    marginRight: 3,
                    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
                  }
                }}
              >Sauvegarder</Button>

            </Form.Item>

          </DialogActions>
        </Form>
      </Dialog>
      <Snackbars severity={'success'} message={message} open={openSuccessBox} setOpen={setOpenSuccessBox} autohideduration={1000} />
      <Snackbars severity={'error'} message={message} open={openErrorBox} setOpen={setOpenErrorBox} autohideduration={1000} />
    </>
  )
}